import { useContext } from 'react'
import { CaptchaContext } from './Captcha.context'

const useCaptcha = () => {
  const providerValue = useContext(CaptchaContext)
  return {
    refresh: providerValue.code.refresh,
    validate: (code: any) => {
      const isValid = code === providerValue.code.value
      return isValid
    }
  }
}

export { useCaptcha }
export default useCaptcha
